@if (eventData(); as event) {
	<div data-test-id="event-detail">
		@if (eventImages().length > 0) {
			<vp-carousel [items]="eventImages()" data-test-id="carousel" />
		}
		<section class="section-spacing bg-white">
			<div class="section-inner section-gap flex-col">
				<div class="column-gap flex-col lg:flex-row">
					<div class="flex-col lg:w-2/3">
						<header>
							<h1
								class="heading-group heading-group-lg"
								data-test-id="event-detail-title"
							>
								{{ event.name }}
							</h1>
							<p
								class="heading-group-overline"
								data-test-id="event-detail-overline"
								role="doc-subtitle"
							>
								{{
									'storyblok.pages.event-detail.overline'
										| translate
								}}
							</p>
						</header>
						@if (event.description) {
							<vp-read-more>
								<markdown
									[data]="event.description"
									class="markdown"
									data-test-id="event-detail-description"
								/>
							</vp-read-more>
						}
						@if (eventDates().length > 0) {
							<vp-list-grid
								[listItems]="eventDates()"
								[sheetTitle]="
									'storyblok.pages.event-detail.all-available-dates'
										| translate
								"
								[title]="
									'storyblok.pages.event-detail.available-dates'
										| translate
								"
								[useCol2]="true"
								headingType="h2"
								name="available-dates"
							/>
						}
						@if (eventInformationBullets().length > 0) {
							<vp-list-grid
								[listItems]="eventInformationBullets()"
								[sheetTitle]="
									'storyblok.pages.event-detail.more-information'
										| translate
								"
								[title]="
									'storyblok.pages.event-detail.more-information'
										| translate
								"
								[useCol2]="true"
								headingType="h2"
								name="event-information"
							/>
						}
						@if (eventFaqs().length > 0) {
							<h2
								class="running-head mb-0"
								data-test-id="faq-header"
							>
								{{
									'storyblok.pages.event-detail.frequently-asked-questions'
										| translate
								}}
							</h2>
							<sb-accordion
								[items]="eventFaqs()"
								data-test-id="event-faqs"
								variant="base"
							/>
						}
					</div>
					<div class="flex-col lg:w-1/3">
						<vp-persuade-card
							[ctaText]="
								`storyblok.pages.event-detail.cta.type-${event.cta.labelKey}`
									| translate
							"
							[ctaUrl]="event.cta.labelKey && event.cta.url"
							[iconColor]="'text-accent-100'"
							[iconList]="eventDetailsIconList()"
							[isHorizontalIconList]="false"
							[price]="event.price"
							[title]="
								'storyblok.pages.event-detail.cta.title'
									| translate
							"
							[useVerticalCard]="true"
							data-test-id="cta-card"
						/>
						@if (
							event?.address?.latitude &&
							event?.address?.longitude
						) {
							<vp-map
								[lat]="event.address.latitude"
								[long]="event.address.longitude"
								className="md:aspect-video"
								data-test-id="location-map"
							/>
						}
					</div>
				</div>
			</div>
		</section>
	</div>
}
